module.exports = __webpack_public_path__ + "static/logo_jakosc_2-7f797fbd2d4e65e5abf11e3b3b7bafce.png";